module.exports = __webpack_public_path__ + "img/clocks.a5d85244.svg";